/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type IndividualRequestedFile = {
    readonly id?: number;
    name: string;
    company_information_request_status?: number | null;
    folder?: number | null;
    reference_object_type?: IndividualRequestedFile.reference_object_type | null;
    reference_object_id?: number | null;
};
export namespace IndividualRequestedFile {
    export enum reference_object_type {
        CT = 'ct',
        FI = 'fi',
        FO = 'fo',
        CB = 'cb',
        EV = 'ev',
        SSV = 'ssv',
        MA = 'ma',
        FIO = 'fio',
    }
}

